"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../createApi");

var LinksApi = function (_BaseApi) {
  (0, _inherits2["default"])(LinksApi, _BaseApi);

  function LinksApi(baseUrl) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      baseUrl: baseUrl
    };
    var apiInstance = arguments.length > 2 ? arguments[2] : undefined;
    (0, _classCallCheck2["default"])(this, LinksApi);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(LinksApi).call(this, baseUrl, options, apiInstance));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createShortLink", function (_ref) {
      var clientId = _ref.clientId,
          deeplink = _ref.deeplink,
          queryParams = _ref.queryParams,
          socialTitle = _ref.socialTitle,
          socialDescription = _ref.socialDescription,
          socialImageLink = _ref.socialImageLink,
          webPath = _ref.webPath;
      return _this.api.post("/clients/".concat(clientId), {
        data: {
          deeplink: deeplink,
          queryParams: queryParams,
          socialTitle: socialTitle,
          socialDescription: socialDescription,
          socialImageLink: socialImageLink,
          webPath: webPath
        }
      });
    });
    return _this;
  }

  return LinksApi;
}(_createApi.BaseApi);

var _default = LinksApi;
exports["default"] = _default;
//# sourceMappingURL=links.js.map